import { getQrDataFieldType } from '../../lib/getQrDataFieldType';
import { doc, updateDoc } from 'firebase/firestore';
import { firestore } from '../../firebase';

// Moves description from nested tracker/survey to root qr_data.data.description
// Directly updates Firestore if nested description exists.
export const migrateDescriptionIfNeeded = async (qr_data, dataDispatch) => {
  try {
    const qrId = qr_data?.id;
    const qrType = qr_data?.data?.qr_type;
    const parentType = getQrDataFieldType(qrType);
    
    if (parentType !== 'tracker' && parentType !== 'survey') return {updated: false, data: ""};

    const nested = qr_data?.data?.[parentType];
    const nestedDesc = nested?.description;
    
    if (typeof nestedDesc !== 'string' || nestedDesc.length === 0) return {updated: false, data: ""};

    dataDispatch({ type: 'description', data: nestedDesc });
    const codeRef = doc(firestore, 'codes', qrId);
    const updateObj = {
      description: nestedDesc,
      [`${parentType}.description`]: ''
    };
    
    await updateDoc(codeRef, updateObj);
    return {updated: true, data: nestedDesc};
  } catch (e) {
    // Non-blocking safeguard
    console.error('migrateDescriptionIfNeeded error:', e?.message || e);
  }
};
